import React from "react";

import type { LineIconProps } from "./types";

const LineIcon = ({ stroke, isDashed = false }: LineIconProps) => (
  <line
    x1={0}
    x2={20}
    y1={6}
    y2={6}
    stroke={stroke}
    strokeWidth={4}
    strokeDasharray={isDashed ? "3,5" : undefined}
  />
);

export default LineIcon;
